import { List, Map, Record } from "immutable";

import { Location, LocationRaw, ZipSuggestion } from "@typings/locations";
import { LOADING_STATE } from "@typings/reduxThunkActions";

export const LOCAL_STORAGE_KEY = "store:locations";

export interface SuggestionsRawResponse {
  city: string;
  zip: string;
  hideCityName: boolean;
}

export interface LocationsReducer {
  defaultLocationId: string;
  invoiceLocationId: string;
  legalLocationId: string;
  locations: Map<string, Record<Location>>;
  b2bLocations: Map<string, Record<Location>>;
  zipSuggestions: List<ZipSuggestion>;
  loadingState: LOADING_STATE;
  b2bLoadingState: LOADING_STATE;
}

export interface IPetsUpdate {
  hasPets: boolean;
}

export interface LocationsRawResponse {
  defaultLocationId: string;
  invoiceLocationId: string;
  legalLocationId: string;
  locations: LocationRaw[];
}
